import { Controller } from "@hotwired/stimulus"
import '../../_jquery';
import 'slick-carousel/slick/slick.min';
import { isBackend } from '../../utils';

export default class extends Controller {
  static targets = ['slider']

  connect() {
    if (isBackend()) {
      this.#backendInitializer()
    } else {
      this.initialize_slick_carousel(this.sliderTarget)
    }
  }

  disconnect() {
    if (this.clonedTarget) {
      this.clonedTarget.remove()
    }
  }

  initialize_slick_carousel(slickTargetElement) {
    let $that, parallax_image_movement, parallax_image_speed, parallax_text_movement, parallax_text_speed, slick_speed;

    $that = $(slickTargetElement)

    slick_speed = $that.data('speed');

    $that.slick({
      adaptiveHeight: true,
      arrows: false,
      dots: false,
      fade: $that.data('fade'),
      autoplay: $that.data('autoplay'),
      speed: slick_speed
    });

    if ($that.data('fade') === false) {
      $that.on('beforeChange', function (event, slick, current, next) {
        let current_slide, direction, next_slide;
        current_slide = slick['$slides'][current];
        next_slide = slick['$slides'][next];

        if (current > next) {
          direction = '+';
        } else {
          direction = '-';
        }

        // Text parallax
        $(current_slide).find('.component-slide__content__text--center').animate({
          marginLeft: `${direction}=${parallax_text_movement}`
        }, parallax_text_speed, 'linear');

        $(next_slide).find('.component-slide__content__text--center').animate({
          marginLeft: '10%'
        }, parallax_text_speed, 'linear');

        $(current_slide).find('.component-slide__content__text').animate({
          marginLeft: `${direction}=${parallax_text_movement}`
        }, parallax_text_speed, 'linear');

        $(next_slide).find('.component-slide__content__text').animate({
          marginLeft: '0'
        }, parallax_text_speed, 'linear');

        // Image parallax
        $(current_slide).find('.component-slide__content__image--center').animate({
          marginLeft: `${direction}=${parallax_image_movement}`
        }, parallax_image_speed, 'linear');

        $(next_slide).find('.component-slide__content__image--center').animate({
          marginLeft: '0'
        }, parallax_image_speed, 'linear');

        $(current_slide).find('.component-slide__content__image').animate({
          marginLeft: `${direction}=${parallax_image_movement}`
        }, parallax_image_speed, 'linear');

        $(next_slide).find('.component-slide__content__image').animate({
          marginLeft: '0'
        }, parallax_image_speed, 'linear');
      });
    }
  }

  // Slick e React (da Gutenberg) non lavorano bene assieme. Quindi adottiamo questo brutto ma
  // efficace trucco: lasciamo che React lavori sul HTML che noi però nascondiamo. Poi cloniamo
  // l' HTML e sul clone ci agganciamo Slick. A questo punto osserviamo i cambiamenti del DOM
  // del HTML originale e se avvengono, quindi se React ri-renderizza, allora noi eliminiamo
  // il nostro carosello, cloniamo da principio l' HTML e quindi re-inizializziamo Slick sul
  // clone.
  #backendInitializer() {
    const cloneAndInsert = () => {
      this.clonedTarget = this.sliderTarget.cloneNode(true)
      this.sliderTarget.style.display = 'none'
      this.clonedTarget.style.display = 'block'
      this.sliderTarget.parentElement.appendChild(this.clonedTarget)
    }

    cloneAndInsert()

    let observer = new window.MutationObserver(function (mutations, observer) {
      this.clonedTarget.remove()

      cloneAndInsert()

      this.initialize_slick_carousel(this.clonedTarget)
    }.bind(this));
    observer.observe(this.sliderTarget, { subtree: true, attributes: true, childList: true });

    this.initialize_slick_carousel(this.clonedTarget)
  }
}
